import AccountType from '@app/constants/AccountType'
import urls from '@app/plugins/urls'
import { accountModule } from '@app/store'

export default function ({
  app,
  store,
  route,
  redirect,
}: {
  app: any
  store: any
  route: any
  redirect: any
}) {
  // salonの場合はサロン用のフォームへリダイレクト
  if (accountModule.accountType === AccountType.salon) {
    window.location.href = urls.salonRepair
  }
}
